import { TApplicationState } from "../rootReducer";

export const getCountriesListSelector = (state: TApplicationState) =>{
    return state.usersAnketa.countriesData.countriesList;
}